<template>
  <div>
    <v-row class="ml-2" justify="start">
      <v-col cols="2">
        <v-select label="Unidad" v-model="uniEje" :items="unidades" dense
          item-text="texto" hide-details item-value="value"></v-select>
      </v-col>
      <v-col cols="2">
        <v-select label="Ambito" v-model="ambito" :items="ambitos" dense
          item-text="texto" hide-details item-value="value"></v-select>
      </v-col>
      <v-col cols="2">
        <v-select label="Coord. Estatal" v-model="coordEst" :items="coordsEst" dense
          item-text="texto" hide-details item-value="value"></v-select>
      </v-col>
      <v-col cols="2">
        <v-tooltip bottom activator="#btn-reload">
          Actualizar
        </v-tooltip>
        <v-btn id="btn-reload" icon @click="loadCorreos"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-col>
      <v-spacer/>
      <v-col cols="2">
        <v-tooltip bottom activator="#btn-add">
          <span>Agregar</span>
        </v-tooltip>
        <v-btn id="btn-add" icon @click="showDlgAdd=true">
          <v-icon >mdi-account-plus-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col columns="12" md="11">
        <v-data-table
          :headers="headerCorreo"
          :items="correos"
          item-key="idCorreoNotifica"
          disable-sort
          dense
          :footer-props="footerProps"
          :items-per-page="10"
          :hide-default-footer="hideFooter"
          :loading="loading"
          loading-text="Cargando datos..."
          class="elevation-2"
          @contextmenu:row="openMenu"
        >

          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              @click="confirmarBorrar(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="showDlgAdd" persistent max-width="500">
      <v-card flat class="pa-0">
        <v-card-title class="pa-0 primary white--text justify-space-between">
            <span class="text-h6 ml-2">Notificar via correo</span>
            <span class="mr-2">
              <v-btn color="white" icon @click="showDlgAdd = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-progress-linear :active="loadingAdd" indeterminate></v-progress-linear>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9">
              <buscar-empleado :value.sync="empleado"></buscar-empleado>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span>{{nombreEmpleado}}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
               <v-combobox
                v-model="campo"
                :items="itemsCampo"
                label="Campo"
                dense
              ></v-combobox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="py-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn id="btn-save" color="primary" text @click="onClickSave">Guardar</v-btn>
          <v-btn id="btn-close" color="primary" text @click="showDlgAdd = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      v-model="showMenu"
      :position-x="xMenu"
      :position-y="yMenu"
      absolute
      offset-y
    >
      <v-list dense>
        <v-list-item :disabled="disabledItem === 0" @click="cambiarPara('PARA')">
          <v-list-item-content>
            <v-list-item-title>Para</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :disabled="disabledItem === 1" @click="cambiarPara('CC')">
          <v-list-item-content>
            <v-list-item-title>Copia</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :disabled="disabledItem === 2" @click="cambiarPara('CCO')">
          <v-list-item-content>
            <v-list-item-title>Copia oculta</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <dialog-message :show.sync="showDlg" :color="colorDlg" :title="titleDlg">
      {{ mensaje }}
    </dialog-message>

    <dialog-confirmar :show="showDlgConfirmar" @selected="onConfirmar($event)">
      {{ mensaje }}
    </dialog-confirmar>
</div>
</template>

<script>
import {mapState} from 'vuex'
import axios from "axios";
import DialogMessage from "@/components/dialogs/DialogMessage.vue";
import DialogConfirmar from "@/components/dialogs/DialogConfirmar.vue";
import BuscarEmpleado from '@/components/dialogs/BuscarEmpleado.vue';
import AccesosUtils from "@/utils/AccesosUtils.js";

export default {
  components: {
    DialogMessage,
    DialogConfirmar,
    BuscarEmpleado
  }, 

  data() {
    return {
      accesosUtils: new AccesosUtils(),
      uniEje: null,
      coordEst: null,
      ambito: null,
      unidades: [],
      coordsEst: [],
      ambitos: [],
      empSearch: null,
      correos: [],
      selected: null,
      inicializado: false,
      observer: true,
      headerCorreo: [
        { text: 'Apellido1', value: 'apellidoPat', class: "accent white--text"},
        { text: 'Apellido2', value: 'apellidoMat', class: "accent white--text"},
        { text: 'Nombre', value: 'nombres', class: "accent white--text"},
        { text: 'Correo', value: 'EMailTrabajo', class: "accent white--text"},
        { text: 'Para', value: 'campo', class: "accent white--text"},
        { text: 'Eliminar', value: 'actions', class: "accent white--text"}
      ],
      footerProps: {
        disableItemsPerPage: true,
      },
      showMenu: false,
      xMenu: 0,
      yMenu: 0,
      disabledItem: -1,
      loading: false,
      showDlg: false,
      mensaje: "",
      colorDlg: 'primary',
      titleDlg: "",
      empleado: null,
      nombreEmpleado: "",
      showDlgAdd: false,
      showDlgConfirmar: false,
      loadingAdd: false,
      campo: 'Para',
      campos: ['PARA', 'CC', 'CCO'],
      itemsCampo: ['Para', 'Copia', 'Copia oculta'],
    }
  }, 

  computed: {
    hideFooter() {
      return this.correos.length < 10;
    },
    ...mapState(['usuario'])
  },

  watch: {
    empleado() {
      if (this.empleado) {
        this.nombreEmpleado = this.empleado.nombres+ " "+ this.empleado.apellidoPat+ " "+ this.empleado.apellidoMat;
      }
    },
    uniEje() {
      if (this.inicializado && this.uniEje && this.observer) {
        this.updateAmbitos();
      }
    },
    ambito() {
      if (this.inicializado && this.ambito && this.observer) {
        this.updateCoordEst();
      }
    },
  },

  methods: {
    init() {
      this.uniEje = this.usuario.unidadEjecutora;
      this.ambito = this.usuario.ambito;
      this.coordEst = this.usuario.coordEstatal.toString();
      this.loadAccesos();
    },
    loadCorreos() {
      this.loading = true;
      axios.get(`/correos/${this.uniEje}/${this.coordEst}/${this.ambito}`)
      .then(response => {
        this.correos = response.data;
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        if (error.response) {
          console.log(error.response);
          this.showError(error.response.data);
        } else {
          console.error(error);
          this.showError("Error en la petición.");
        }
      });
    },
    onClickSave() {
      this.showDlgAdd = false;
      const numEmp = this.empleado.numEmpleado;
      const esta = this.correos.some(co => co.numEmpleado === numEmp);
      if (!esta) {
        this.saveCorreo();
      }
    },
    saveCorreo() {
      const correoNotifica = this.createCorreoNotifica();
      axios.post('/correos', correoNotifica)
      .then(() =>{
        this.loadCorreos();
      })
      .catch(error => {
        if (error.response) {
          console.log(error.response);
          this.showError(error.response.data);
        } else {
          console.error(error);
          this.showError("Error en la petición.");
        }
      });
    },
    createCorreoNotifica() {
      //const campos = ['PARA', 'CC', 'CCO'];
      const indx = this.itemsCampo.findIndex(item => item === this.campo);
      return {
        idCorreoNotifica: 0,
        unidadEjecutora: this.uniEje,
        coordEstatal: this.coordEst,
        ambito: this.ambito,
        modulo: 'JUSTIFICANTES',
        numEmpleado: this.empleado.numEmpleado,
        campo: this.campos[indx]
      };
    },
    loadAccesos() {
      this.accesosUtils.loadAccesos(this.usuario, (unidades, ambitos, ces) => {
        this.observer = false;
        this.unidades = unidades;
        this.ambitos = ambitos;
        this.coordsEst = ces;
        this.observer = true;
        this.inicializado = true;
        this.loadCorreos();
      });
    },
    updateAmbitos() {
      this.accesosUtils.loadAccesosUniEje(this.uniEje, (ambitos, ces) => {
        this.observer = false;
        this.ambitos = ambitos;
        if (ambitos && ambitos.length > 0) {
          this.ambito = ambitos[0].value;
        }
        this.coordsEst = ces;
        if (ces && ces.length > 0) {
          this.coordEst = ces[0].value;
        }
        this.observer = true;
      });
    },
    updateCoordEst() {
      this.accesosUtils.loadAccesosAmb(this.uniEje, this.ambito, (ces) => {
        this.coordsEst = ces;
        if (ces && ces.length > 0) {
          this.coordEst = ces[0].value;
        }
      });
    },
    openMenu(event, item) {
      event.preventDefault();
      this.selected = item.item;
      this.disabledItem = this.campos.findIndex(it => it === this.selected.campo);
      this.showMenu = false;
      this.xMenu = event.clientX;
      this.yMenu = event.clientY;
      this.$nextTick(() => this.showMenu = true);
    },
    cambiarPara(para) {
      const dto = {
        idCorreoNotifica: this.selected.idCorreoNotifica,
        unidadEjecutora: this.uniEje,
        coordEstatal: this.coordEst,
        ambito: this.ambito,
        modulo: 'JUSTIFICANTES',
        numEmpleado: this.selected.numEmpleado,
        campo: para
      };
      axios.put('/correos', dto)
      .then(() =>{
        this.loadCorreos();
      })
      .catch(error => {
        if (error.response) {
          console.log(error.response);
          this.showError(error.response.data);
        } else {
          console.error(error);
          this.showError("Error en la petición.");
        }
      });
    },
    confirmarBorrar(item) {
      this.selected = item;
      this.mensaje = `Eliminar el correo ${item.EMailTrabajo}?`;
      this.showDlgConfirmar = true;
    },
    onConfirmar(eliminar) {
      this.showDlgConfirmar = false;
      if (eliminar) {
        axios.delete(`/correos/${this.selected.idCorreoNotifica}`)
        .then(() =>{
          this.loadCorreos();
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response);
            this.showError(error.response.data);
          } else {
            console.error(error);
            this.showError("Error en la petición.");
          }
        });
      }
    },
    showError: function (message) {
      this.mensaje = message;
      this.colorDlg = "error";
      this.titleDlg = "Error",
      this.showDlg = true;
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style>

</style>